define('shared/util/dom/expression/evaluateRawString',['shared/lib/RSVP', 'shared/util/dom/expression/Evaluator', 'shared/lib/console', 'shared/lib/JSON3'],
function (RSVP, Evaluator, console, JSON) {
    'use strict';

    return function (rawText){

        var REGEX_SEARCH = /\$\{([\s\S]*?)\}/g;
        if(!rawText || !REGEX_SEARCH.test(rawText)){
            return RSVP.resolve(rawText);
        }

        var expressionAndResultDic = {};
        var allCalculations = [];

        rawText.replace(REGEX_SEARCH, function(match, dieExpression){
            console.log('evaluateRawString phase 1 found expression: ', dieExpression);

            var dieEvaluator = new Evaluator();
            allCalculations.push(
                dieEvaluator.evaluate(dieExpression)
                    .then(function(expressionValue){
                        expressionAndResultDic[dieExpression] = expressionValue;
                    })
            );

            return '';
        });

        return RSVP.all(allCalculations)
            .then(function(){
                console.log('evaluateRawString all expressions have been calculated: ', JSON.stringify(expressionAndResultDic));
                return rawText.replace(REGEX_SEARCH, function(match, dieExpression){
                    console.log('evaluateRawString phase 2 found expression: ', dieExpression);
                    return expressionAndResultDic[dieExpression];
                });
            });
    };
});
